"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delaySubscriptionHandler = delaySubscriptionHandler;
exports.dispatchDelaySubscriptionFailedEvent = void 0;
var DelaySubscriptionFailed = _interopRequireWildcard(require("@ori-events/delay-subscription-failed"));
var _checkoutUtils = require("@ori/checkout-utils");
var _types = require("../types");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const dispatchDelaySubscriptionFailedEvent = detail => {
  const event = new CustomEvent(DelaySubscriptionFailed.Name, {
    detail
  });
  window.dispatchEvent(event);
};
exports.dispatchDelaySubscriptionFailedEvent = dispatchDelaySubscriptionFailedEvent;
async function delaySubscriptionHandler({
  detail: {
    cycle,
    placement,
    step,
    subscriptionId
  }
}) {
  const response = await fetch(_types.RequestUrl.DelaySubscription, (0, _utils.getHttpRequestSettings)({
    cycle,
    placement,
    step,
    subscriptionId
  }, _checkoutUtils.HttpMethod.Post));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if (DelaySubscriptionFailed.isDelaySubscriptionErrorResponse(data)) {
    dispatchDelaySubscriptionFailedEvent(data);
    return false;
  }
  return data;
}